// extracted by mini-css-extract-plugin
export default {"verticalSelectionContainer":"_20130760","verticalSelection":"_d055587","fieldLabel":"_47d752f1","tooltip":"_e056f260","questionMark":"_9533d24e","mobileHint":"_ddeb646e"};